import axios from '@/plugins/axiosInstance'
import { socialMedia } from '@/networking/urlManager'
import { responseHandlerService } from '@/plugins/responseHandlerService'

/**
 * Save generated content to the backend
 * @param {Object} content - Content to save
 * @param {string} assetId - Asset ID
 * @returns {Promise<Object>} Saved content response
 */
export const saveContent = async (content, assetId) => {
  try {
    const payload = {
      ...content,
      assetId: assetId,
    }

    const response = await axios.post(socialMedia.savePost, payload)
    return response.data.data
  } catch (error) {
    console.error('Error saving content:', error)
    responseHandlerService.handleError('Failed to save content. Please try again.')
    throw error
  }
}

/**
 * Publish content to social media platforms
 * @param {Object} content - Content to publish
 * @param {string} assetId - Asset ID
 * @param {Array} platforms - Platforms to publish to
 * @returns {Promise<Object>} Published content response
 */
export const publishContent = async (contentId, assetId, platforms) => {
  try {
    const payload = {
      rowId: contentId,
      assetId: assetId,
      platforms: platforms,
    }

    const response = await axios.post(socialMedia.publishPost, payload)
    return response.data.data
  } catch (error) {
    console.error('Error publishing content:', error)
    responseHandlerService.handleError('Failed to publish content. Please try again.')
    throw error
  }
}
